/**
 * Class representing a text model with CSS classes for styling.
 */

export default class TextModel {
  /**
   * Create a TextModel.
   * @param {string} text - The text content.
   * @param {string[]} [cssClasses=[]] - An array of CSS classes.
   */
  constructor(text, cssClasses = []) {
    /**
     * The text content.
     * @type {string}
     */
    this.text = text

    /**
     * An array of CSS classes.
     * @type {string[]}
     */
    this.cssClasses = cssClasses
  }

  /**
   * Add a CSS class to the list if it isn't already present.
   * @param {string} cssClass - The CSS class to add.
   */
  addClass(cssClass) {
    if (!this.cssClasses.includes(cssClass)) {
      this.cssClasses.push(cssClass)
    }
  }

  /**
   * Remove a CSS class from the list.
   * @param {string} cssClass - The CSS class to remove.
   */
  removeClass(cssClass) {
    this.cssClasses = this.cssClasses.filter((cls) => cls !== cssClass)
  }

  /**
   * Get the list of CSS classes as a space-separated string.
   * @returns {string} The space-separated CSS classes.
   */
  getClasses() {
    return this.cssClasses.join(' ')
  }
}
